module.exports = __webpack_public_path__ + "assets/ip.7153cb83.svg";